exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ec-compare-button {\n  padding: 15px 15px;\n  background: #D0D3DA;\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  -webkit-box-align: center;\n          align-items: center;\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-pack: center;\n          justify-content: center;\n}\n.ec-compare-button .ec-icon {\n  color: #FDFFFD;\n  font-size: 16px;\n}\n.ec-compare-button:hover, .ec-compare-button.active {\n  background: #5AD060;\n}", ""]);

// exports
